var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-chargebee-account" },
    [
      _c("h3", { staticClass: "typographies-heading-h3" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Gérer mon abonnement")))
      ]),
      _vm._v(" "),
      _vm._l(_vm.actions, function(action) {
        return _c(
          "div",
          {
            key: action.section,
            staticClass: "manage-chargebee-account__container-btn"
          },
          [
            _c("CompassPlainButton", {
              attrs: { label: action.labelBtn },
              on: {
                click: function($event) {
                  return _vm.openCbPortalSection(action.section)
                }
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }